import { PlusIcon } from '@langchain/untitled-ui-icons';

import { Button } from '@/design-system';
import { useHostListeners } from '@/hooks/useSwr';

import { HostProjectCrudPane } from './HostProjectCrudPane';

export function HostProjectCrudPaneWithButton({
  open,
  setIsOpen,
}: {
  open: boolean;
  setIsOpen: (open: boolean) => void;
}) {
  const { data: listeners } = useHostListeners({});

  return (
    <>
      <Button
        size="md"
        onClick={() => setIsOpen(true)}
        leftDecorator={PlusIcon}
      >
        New Deployment
      </Button>
      <HostProjectCrudPane
        listeners={listeners?.resources}
        isOpen={open}
        doClose={() => setIsOpen(false)}
      />
    </>
  );
}
